import { Directive, TemplateRef, inject } from '@angular/core';

@Directive({
  selector: '[diNavbarMenuItemLabel]',
  standalone: true,
})
export class NavbarMenuItemLabelDirective {
  readonly template = inject(TemplateRef);
}
